import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PasswordReminderRequestBody, PasswordReminderResponse } from "./types";

export class PasswordReminderAPI extends BaseAPI<
  PasswordReminderRequestBody,
  PasswordReminderResponse
> {
  protected route = ApiRoutes.auth.password_reminder;
  protected method = RequestMethod.POST;
}
